import React from 'react';
import { FiUsers } from 'react-icons/fi';
import ActionButton from './ActionButton';

const SellerButton = ({ onClick, title = "Seller List", className = "" }) => {
  return (
    <ActionButton
      icon={FiUsers}
      onClick={onClick}
      title={title}
      className={className}
    />
  );
};

export default SellerButton;